// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_ConfirmPeriodResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /payroll/confirm_period
 * Confirms period and creates consolidated despesas
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Payroll_ConfirmPeriodResponseDados {
despesas: unknown[]
despesas_created: number
status: string
message?: string
}

export type Payroll_ConfirmPeriodResponse = ApiResponse<Payroll_ConfirmPeriodResponseDados>;

registerResponseContract('Payroll_ConfirmPeriodResponse', {
  despesas:         { type: 'array',   required: true },
  despesas_created: { type: 'number',  required: true },
  status:           { type: 'string',  required: true },
  message:          { type: 'string',  required: false },
})
